<template>
  <div
    class="photo-swipe-gallery | pswp"
    ref="mainFullScreenGallery"
    :id="id"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div
      class="pswp__bg"
      @click="closeZoom"
    />
    <div class="pswp__scroll-wrap">
      <div class="pswp__container">
        <div class="pswp__item" />
        <div class="pswp__item" />
        <div class="pswp__item" />
      </div>
      <div class="pswp__ui pswp__ui--hidden">
        <div class="pswp__top-bar">
          <div class="pswp__counter" />
          <button
            class="pswp__button pswp__button--fs"
            :title="$t('photoSwipe.toggle')"
          />
          <button
            class="pswp__button pswp__button--zoom"
            :title="$t('photoSwipe.zoom')"
          />
          <button
            class="pswp__button pswp__button--share"
            title="Share"
          />
          <button
            class="pswp__button pswp__button--close"
            :title="$t('photoSwipe.close')"
            @click="closeZoom"
          />
          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut" />
              </div>
            </div>
          </div>
        </div>
        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
          <div class="pswp__share-tooltip" />
        </div>
        <button
          class="pswp__button pswp__button--arrow pswp__button--arrow--left"
          :title="$t('photoSwipe.arrowLeft')"
        />
        <button
          class="pswp__button pswp__button--arrow pswp__button--arrow--right"
          :title="$t('photoSwipe.arrowRight')"
        />
        <div class="pswp__caption">
          <div class="pswp__caption__center" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  // HTML structure is required by PhotoSwipe
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import * as PhotoSwipe from 'photoswipe';
  import * as PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
  import pigeon from '../../utilities/js/pigeon/pigeon.js';
  import productStore, {ProductStore} from '../../stores/product/ProductStore';
  import ProductDetails from '../../types/ProductDetails';

  @Options({
    name: 'photo-swipe-gallery',
  })
  export default class PhotoSwipeGallery extends Vue {
    @Prop()
    id: String;

    @Prop()
    productName: String;

    productStore: ProductStore = productStore;

    gallery: any;
    isVisible: boolean = false;

    get productDetails(): ProductDetails {
      return this.productStore.productDetails;
    }

    mounted() {
      pigeon.subscribe('productgallery:imageclicked', this.toggleClickHandler.bind(this));
      const zoomBtn = document.querySelector('.photo-swipe__zoom-btn');

      if (zoomBtn) {
        window.onpopstate = event => this.onPopState();

        zoomBtn.addEventListener('click', event => this.openZoom());
      }
    }

    onPopState() {
      if (window.location.hash.indexOf('zoom=1') < 0 && this.isVisible) {
        this.isVisible = false;
        this.gallery.close();
      }
    }

    openZoom() {
      this.isVisible = true;

      const paginationButtons = document.querySelectorAll('.product-gallery .carousel__pagination-button');
      if (!paginationButtons || paginationButtons.length < 1) {
        this.select(0);
      }
      for (let i = 0; i < paginationButtons.length; i++) {
        if (paginationButtons[i].classList.contains('carousel__pagination-button--active')) {
          this.select(i);
          break;
        }
      }
    }

    closeZoom() {
      if (this.isVisible) {
        this.isVisible = false;
        history.back();
      }
    }

    toggleClickHandler(options) {
      if (options.id === this.id) {
        this.isVisible = true;
        window.location.hash = '#zoom=1';
        if ('showImage' in options) {
          this.select(options.showImage);
        } else {
          this.select(0);
        }
      }
    }

    private select(index) {
      this.initGallery(index);
    }

    private initGallery(index) {
      let options = {
        index: index,
        showHideOpacity: true,
        bgOpacity: 0.8,
        spacing: 0.1,
        shareEl: false,
        closeEl: true,
        captionEl: true,
        fullscreenEl: true,
        zoomEl: true,
        loop: false,
        history: false,
        preloaderEl: false,
        preload: [1, 1]
      };


      let items = this.productDetails.images.map((image) => {
        // w and h same as in template.xml in iview config
        return {
          src: image.zoom,
          title: this.productName,
          w: 2000,
          h: 2000
        }
      });

      this.gallery = new PhotoSwipe(<HTMLElement> this.$refs.mainFullScreenGallery, PhotoSwipeUI_Default, items, options);
      this.gallery.init();

      this.gallery.listen('unbindEvents', () => {
        let getCurrentIndex = this.gallery.getCurrentIndex();
        pigeon.publish('swipeGallery:indexUpdate', {currentIndex: getCurrentIndex});
      });
    }
  }
</script>
